<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <form action="#" @submit.prevent="submit_form" @reset="reset_form">
              <!-- 雾化丝名称 -->
              <div class="form-group">
                <b-col lg="10">
                  <b-form-group
                    label="Cartridge Type"
                    label-cols-sm="4"
                    label-align-sm="right"
                    label-for="cartridge-type"
                    label-class="requiredRow"
                  >
                    <b-form-input
                      id="cartridge-type"
                      v-model="typeform.typeName"
                      placeholder="Please enter"
                      trim
                      required
                      oninvalid="setCustomValidity('Please enter');"
                      oninput="setCustomValidity('');if(value.length > 50)value = value.slice(0, 50)"
                    >
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </div>

              <!-- 备注 -->
              <div class="form-group">
                <b-col lg="10">
                  <b-form-group
                    label="Notes"
                    label-cols-sm="4"
                    label-align-sm="right"
                    label-for="remark"
                  >
                    <b-form-textarea
                      id="remark"
                      v-model="typeform.remarks"
                      placeholder="Enter Notes"
                      rows="3"
                      max-rows="6"
                    ></b-form-textarea>
                  </b-form-group>
                </b-col>
              </div>

              <div class="form-group mb-0">
                <div class="text-center">
                  <button type="submit" class="btn btn-primary">Confirm</button>
                  <button type="reset" class="btn btn-secondary m-l-5 ml-1">
                    Cancel </button>
                </div>
              </div>
            </form>
          </div>
          <!-- end card-body -->
        </div>
      </div>
      <!-- end col-->
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { dropzoneOptions } from "@/api/upload";
import vue2Dropzone from "vue2-dropzone";

export default {
  name: "cartridgeTypeAdd",
  page: {
    title: "Cartridge Type",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    vueDropzone: vue2Dropzone,
    Layout,
    PageHeader,
  },

  data() {
    return {
      dropzoneOptions: dropzoneOptions,
      title: "Cartridge Type",
      items: [
        {
          text: "Data Dictionary",
          // href: "/"
        },
        {
          text: "Cartridge Type",
          // href: "/"
        },
        {
          text: /add/i.test(location.href)?"Cartridge Type Create":"Cartridge Type Modify",
          active: true,
        },
      ],
      typeform: {
        //"id":3,
        typeName: "",
        remarks: "",
      },
      submit: false,
      typesubmit: false,
    };
  },
  computed: {
    is_add: function() {
      return /add/i.test(location.href);
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    show1() {
      this.typeform = {
        id: this.$route.params.id,
        typeName: this.$route.params.typeName,
        remarks: this.$route.params.remarks,
      }
    },
    init() {
      if (this.is_add) {
      } else {
        this.show1();
      }
    },
    add() {
      this.$api.Flavor.cartridgeAdd(this.typeform).then((res) => {
        if(res.message){
              this.$bvToast.toast(res.message);
            }
        if (res.success) {
          this.$router.go(-1);
        } else {
        }
      });
    },
    update() {
      this.$api.Flavor.cartridgeUpdate(this.typeform).then((res) => {
        if(res.message){
              this.$bvToast.toast(res.message);
            }
        if (res.success) {
          this.$router.go(-1);
        } else {
        }
      });
    },
    submit_form() {
      this.typesubmit = true;
      if (this.is_add) {
        this.add();
      } else {
        this.update();
      }
    },
    reset_form() {
      this.$router.go(-1);
    }
  },
};
</script>
